import { keyframes, cx, css } from 'emotion';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from '@hig/theme-context';
import { createCustomClassNames } from '@hig/utils';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(["\n    from {\n      transform: translateX(-100%);\n    }\n    to {\n      transform: translateX(200px);\n    }\n  "], ["\n    from {\n      transform: translateX(-100%);\n    }\n    to {\n      transform: translateX(200px);\n    }\n  "]);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function getProgressBarIndeterminateRules() {
  var indeterminateCycle = keyframes(_templateObject);

  return {
    animation: "2s linear infinite " + indeterminateCycle
  };
}

function getProgressBarFillIndeterminateRules(themeData) {
  return {
    "&:before": {
      content: "\"\"",
      position: "absolute",
      right: "2px",
      width: "200px",
      height: "4px",
      backgroundImage: "linear-gradient(135deg, transparent, " + themeData["progress.bar.highlightColor"] + " 100%)",
      backgroundSize: "200px 4px"
    }
  };
}

/**
 * @param {Number} percent, an integer or float
 * @returns {Integer}
 */
var renderedBarWidth = function renderedBarWidth(percent) {
  var percentageWidth = parseInt(percent, 10);
  if (!percentageWidth) {
    return null;
  }

  if (percentageWidth >= 100) {
    return 101;
  }
  return percentageWidth;
};

function stylesheet(props, themeData) {
  var percentComplete = props.percentComplete,
      customStylesheet = props.stylesheet;

  var isIndeterminate = percentComplete === null || percentComplete === undefined;

  var styles = {
    wrapper: {
      position: "relative",
      borderRadius: themeData["progress.bar.borderRadius"],
      backgroundColor: themeData["progress.bar.backgroundColor"],
      overflow: "hidden",
      width: "100%",
      height: themeData["progress.bar.minHeight"]
    },
    progressBar: _extends({
      position: "absolute",
      top: 0,
      bottom: 0,
      left: "-3px",
      display: "flex",
      alignItems: "stretch",
      transition: "width 0.3s ease-in-out",
      width: isIndeterminate ? "100%" : renderedBarWidth(props.percentComplete) + "%"
    }, isIndeterminate ? getProgressBarIndeterminateRules(themeData) : {}),
    progressBarFill: _extends({
      backgroundColor: isIndeterminate ? "transparent" : themeData["progress.bar.highlightColor"],
      flex: "1 1 0"
    }, isIndeterminate ? getProgressBarFillIndeterminateRules(themeData) : {}),
    polygon: {
      fill: themeData["progress.bar.highlightColor"]
    }
  };

  return customStylesheet ? customStylesheet(styles, props, themeData) : styles;
}

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProgressBar = function (_Component) {
  _inherits(ProgressBar, _Component);

  function ProgressBar() {
    _classCallCheck(this, ProgressBar);

    return _possibleConstructorReturn(this, (ProgressBar.__proto__ || Object.getPrototypeOf(ProgressBar)).apply(this, arguments));
  }

  _createClass(ProgressBar, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          percentComplete = _props.percentComplete,
          customStylesheet = _props.stylesheet,
          otherProps = _objectWithoutProperties(_props, ["percentComplete", "stylesheet"]);

      var className = otherProps.className;

      var innerWrapperClassNames = createCustomClassNames(className, "progress-bar");
      var fillClassNames = createCustomClassNames(className, "fill");
      var polygonClassNames = createCustomClassNames(className, "polygon");

      return React.createElement(
        ThemeContext.Consumer,
        null,
        function (_ref) {
          var resolvedRoles = _ref.resolvedRoles;

          var styles = stylesheet({ percentComplete: percentComplete, stylesheet: customStylesheet }, resolvedRoles);
          return React.createElement(
            "div",
            {
              className: cx(css(styles.wrapper), className),
              role: "progressbar",
              "aria-valuemin": "0",
              "aria-valuemax": "100",
              "aria-valuenow": percentComplete
            },
            React.createElement(
              "div",
              {
                className: cx(css(styles.progressBar), innerWrapperClassNames)
              },
              React.createElement("div", {
                className: cx(css(styles.progressBarFill), fillClassNames)
              }),
              React.createElement(
                "svg",
                {
                  width: "3px",
                  height: "4px",
                  viewBox: "0 0 3 4",
                  version: "1.1",
                  xmlns: "http://www.w3.org/2000/svg",
                  xmlnsXlink: "http://www.w3.org/1999/xlink"
                },
                React.createElement("polygon", {
                  className: cx(css(styles.polygon), polygonClassNames),
                  id: "end-right",
                  points: "0 0 2.68 0 1 4 0 4"
                })
              )
            )
          );
        }
      );
    }
  }]);

  return ProgressBar;
}(Component);

ProgressBar.propTypes = {
  /**
   * A number from 0 to 100 representing the percent the delayed operation has completed
   */
  percentComplete: PropTypes.number,
  /**
   * Adds custom/overriding styles
   */
  stylesheet: PropTypes.func
};
ProgressBar.__docgenInfo = {
  "description": "",
  "displayName": "ProgressBar",
  "props": {
    "percentComplete": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "A number from 0 to 100 representing the percent the delayed operation has completed"
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Adds custom/overriding styles"
    }
  }
};

export default ProgressBar;
